export const ItemPreview = {
  extends: ['Flex', 'Link'],
  flow: 'column',
  align: 'space-between flex-start',
  gap: 'C2',
  round: 'radiusControl',
  padding: 'A1 A1',
  whiteSpace: 'nowrap',
  href: (el) => {
    const key = el.getAppKey()
    return key ? '/account/' + key.split('.')[0] : null
  },
  transition: 'A defaultBezier',
  transitionProperty: 'background, box-shadow',
  // `common-card-outline-interactive` is retired (DESIGN_LANGUAGE §2.4 —
  // alias `card`; -interactive variants replaced by the §4.3 washes) and
  // carried a raw '2px' outline on top. Card outlines are banned
  // (design-direction.md §8) — an opaque `card` fill plus a lift on hover
  // (§2.3 `float`) is the prescribed interactive-card treatment, same as
  // tickets/Cards.js.
  theme: 'card',
  ':hover': { shadow: 'float' },
  fontWeight: '400'
}
